var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClari(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3475 6.6969L15.6582 8.51395C15.9288 9.76897 16.0714 11.0996 16.0714 12.4957C16.0714 13.8918 15.9277 15.2214 15.6582 16.4775L22.3475 18.2946C22.7754 16.482 23 14.4956 23 12.4969C23 10.4981 22.7754 8.50945 22.3475 6.6969Z",
    fill: "#00D7B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40967 4.81921L1 12.4948L7.97889 7.2581C7.30961 6.25479 6.43825 5.42865 5.40967 4.81921Z",
    fill: "#5F3AD7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40967 20.1717L1 12.495L7.97889 17.7316C7.30961 18.7361 6.43825 19.5623 5.40967 20.1717Z",
    fill: "#5F3AD7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4546 3.15051L1 12.4955L15.6589 8.51377C15.23 6.52172 14.4787 4.71818 13.4546 3.15051Z",
    fill: "#0280FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4546 21.8398L1 12.4948L15.6589 16.4766C15.23 18.4697 14.4787 20.2733 13.4546 21.8398Z",
    fill: "#0280FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0733 12.4948C16.0733 11.0987 15.9296 9.76911 15.6601 8.51294L1 12.4948L15.6589 16.4766C15.9307 15.2192 16.0733 13.8931 16.0733 12.4948Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClari);
export default __webpack_public_path__ + "static/media/clari.1f4398ccf77fe8143a0e7d371d0ac478.svg";
export { ForwardRef as ReactComponent };